<template>
  <div>
    <a-form :layout="formLayout" :form="form">
      <a-form-item :wrapper-col="buttonItemLayout.wrapperCol">
        <h3>基本信息：</h3>
      </a-form-item>

        <a-form-item
            label="研究方案名称"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
        >
            <a-textarea
                :autosize="{ minRows: 3, maxRows: 10 }"
                placeholder="请输入"
                allowClear
                v-decorator="['name',{initialValue:name,rules:[{required:true,message: '研究方案名称必填'}]}]"
            />
        </a-form-item>


        <a-form-item
            label="方案编号"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
        >
            <a-input
                allowClear
                v-decorator="[
            'plan_number',
            {
              initialValue: plan_number,
            }
          ]"
                placeholder="请输入方案编号"
            />
        </a-form-item>


        <a-form-item
            label="申办方"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
        >
            <a-input
                allowClear
                v-decorator="[
            'sponsor',
            {
              initialValue: sponsor,
            }
          ]"
                placeholder="请输入申办方"
            />
        </a-form-item>


        <a-form-item
        label="项目介绍"
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
      >
        <a-textarea
          :autosize="{ minRows: 6, maxRows: 20 }"
          placeholder="请输入"
          allowClear
          v-decorator="['introduce',{initialValue:introduce,rules:[{required:true,message: '项目介绍必填'}]}]"
        />
      </a-form-item>

        <a-form-item
            label="是否支持患者不经过医生直接签署"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
        >
            <a-radio-group  buttonStyle="solid" v-decorator="['can_direct_signature',{initialValue:can_direct_signature}]">
                <a-radio-button value="1">允许</a-radio-button>
                <a-radio-button value="0">不允许</a-radio-button>
            </a-radio-group>
        </a-form-item>


        <a-form-item
            label="是否必须让患者录像阅读相关文字"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
        >
            <a-radio-group v-model="need_video"   buttonStyle="solid" v-decorator="['need_video',{initialValue:need_video}]">
                <a-radio-button value="1">必须</a-radio-button>
                <a-radio-button value="0">不必须</a-radio-button>
            </a-radio-group>
        </a-form-item>


        <a-form-item

            label="视频录像阅读文本"
            v-if="need_video==='1'"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
        >
            <a-input
                allowClear
                v-decorator="[
            'video_text',
            {
              initialValue: video_text,
            }
          ]"
                placeholder="请输入"
            />
        </a-form-item>






        <a-form-item :wrapper-col="buttonItemLayout.wrapperCol">
            <h3>入选条件：</h3>
            <a-button type="primary" @click="addStandardSelectedCount">增加一条入选条件</a-button>
        </a-form-item>

        <div v-for="i in StandardSelectedCount">
            <div style="background-color:#E8E8E8;margin-top:50px;padding-bottom: 50px;" v-if="closeSSList.indexOf(i)===-1">
                <!-- Success Description -->
                <!-- <span style="color: red">Success</span> Description Success Description -->
                <a-icon
                    :style="{ fontSize: '16px', color: '#1296db' ,margin:'20px'}"
                    type="close"
                    @click="closeSS(i)"
                />

                <a-form-item
                    :label="'入选条件'+i"
                    :label-col="formItemLayout.labelCol"
                    :wrapper-col="formItemLayout.wrapperCol"
                >
                    <a-input
                        placeholder="请输入"
                        allowClear
                        v-decorator="['standard_selected_'+i,{initialValue:standard_selected[i-1]?standard_selected[i-1]:''}]"
                    />
                </a-form-item>
            </div>
        </div>




        <a-form-item :wrapper-col="buttonItemLayout.wrapperCol">
            <h3>排除标准：</h3>
            <a-button type="primary" @click="addStandardExcludeCount">增加一条排除标准</a-button>
        </a-form-item>

        <div v-for="i in StandardExcludeCount">
            <div style="background-color:#E8E8E8;margin-top:50px;padding-bottom: 50px;" v-if="closeSEList.indexOf(i)===-1">
                <!-- Success Description -->
                <!-- <span style="color: red">Success</span> Description Success Description -->
                <a-icon
                    :style="{ fontSize: '16px', color: '#1296db' ,margin:'20px'}"
                    type="close"
                    @click="closeSE(i)"
                />


                <a-form-item
                    :label="'排除标准'+i"
                    :label-col="formItemLayout.labelCol"
                    :wrapper-col="formItemLayout.wrapperCol"
                >
                    <a-input
                        placeholder="请输入"
                        allowClear
                        v-decorator="['standard_exclude_'+i,{initialValue:standard_exclude[i-1]?standard_exclude[i-1]:''}]"
                    />
                </a-form-item>
            </div>
        </div>



      <a-form-item
          style="margin-top: 50px"
        label="知情同意书"
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
        help="只能选择单个文件"
      >
        <!-- v-decorator="['informed_consent',{initialValue:defaultFileList,rules:[{required:true,message: '请上传知情同意书'}]}]" -->

        <a-upload
            :data="file_data"
            :fileList="fileList"
          v-decorator="['informed_consent']"
          accept=".pdf"
          name="file"
          :multiple="false"
          :action="uploadURL"
          :withCredentials="withCredentials"
          :headers="headers"
          @change="handleChange1"
          @preview="handlePreview"
        >
          <a-button>
            <a-icon type="upload" />点击上传
          </a-button>
        </a-upload>
      </a-form-item>

      <a-form-item :wrapper-col="buttonItemLayout.wrapperCol">
        <h3>其它资料信息上传：</h3>
        <a-button type="primary" @click="addAnnex">增加一条附件信息</a-button>
      </a-form-item>
      <div v-for="i in count">
        <div style="background-color:#E8E8E8;margin-top:50px;padding-bottom: 50px;" v-if="closeList.indexOf(i)===-1">
          <!-- Success Description -->
          <!-- <span style="color: red">Success</span> Description Success Description -->
          <a-icon
            :style="{ fontSize: '16px', color: '#1296db' ,margin:'20px'}"
            type="close"
            @click="closeAnnex(i)"
          />
          <a-form-item
            label="信息名称"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-input
              placeholder="请输入"
              allowClear
              v-decorator="['title_'+i,{initialValue:annexs[i-1]?annexs[i-1].title:''}]"
            />
          </a-form-item>

            <a-form-item
                label="患者必知"
                :label-col="formItemLayout.labelCol"
                :wrapper-col="formItemLayout.wrapperCol"
            >
                <a-radio-group  buttonStyle="solid" v-decorator="['need_read_'+i,{initialValue:annexs[i-1]&&annexs[i-1].need_read?'1':'0'}]">
                    <a-radio-button value="1">必知</a-radio-button>
                    <a-radio-button value="0">不必知</a-radio-button>
                </a-radio-group>
            </a-form-item>

          <a-form-item
            extra="  "
            label="信息介绍"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-textarea
              :autosize="{ minRows: 6, maxRows: 20 }"
              placeholder="请输入"
              allowClear
              v-decorator="['introduce_'+i,{initialValue:annexs[i-1]?annexs[i-1].introduce:''}]"
            />
          </a-form-item>

          <a-form-item
            label="附件资料"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <!-- :fileList="annexs[i-1].annexs" -->
            <!-- :defaultFileList="annexs[i-1].annexs" -->
            <!-- v-decorator="['annex_'+i,{initialValue:annexs[i-1].introduce}]" -->
            <!-- getValueFromEvent: normFile, -->
            <a-upload
                :data="file_data"

                :defaultFileList="annexs[i-1]?annexs[i-1].annexs:[]"
              v-decorator="['annex_'+i,{
            initialValue:annexs[i-1]?annexs[i-1].annexs:[]
             }]"
              name="file"
              :multiple="true"
              :action="uploadURL+i"
              :withCredentials="withCredentials"
              :headers="headers"
              @change="handleChange"
            >
              <a-button>
                <a-icon type="upload" />点击上传
              </a-button>
            </a-upload>
          </a-form-item>
        </div>
      </div>

      <a-form-item :wrapper-col="buttonItemLayout.wrapperCol">
        <a-button type="primary" @click="handleSubmit">点击保存</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import request from "../../utils/request";
import Global from "../../global_variable";
export default {
  data() {
    return {
        plan_number:'',
        sponsor:'',
        uploadURL:Global.uploadURL,
      formLayout: "horizontal",
      form: this.$form.createForm(this),
      old: {},
      name: "",
      introduce: "",
      accept: Global.accept,
      //设置上传的请求头部，IE10 以上有效
      headers: {
        authorization: "authorization-text"
      },
        file_data:{
            authority:500
        },
      //上传请求时是否携带 cookie
      withCredentials: true,
      fileList: [],
      count: 0,
        can_direct_signature:'0',
        StandardSelectedCount:0,
        StandardExcludeCount:0,
      annexs: [],
        standard_selected:[],
        standard_exclude:[],
      closeList: [],
      closeSSList: [],
      closeSEList: [],
        need_video:'0',
        video_text:'',
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    formItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 }
          }
        : {};
    },
    buttonItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            wrapperCol: { span: 14, offset: 4 }
          }
        : {};
    }
  },
  methods: {
    normFile(e) {
      console.log("Upload event:", e);
      if (Array.isArray(e)) {
        return e;
      }
      return e && e.fileList;
    },
    getData() {
      request({
        url: "/project/" + this.$route.query.the_id+"/",
        method: "get",
        params: {}
      }).then(response => {
        let data = response.data;
        if (data.success) {
          // this.form.resetFields();
          this.old = data.data;
          this.name = data.data.item.name;
          this.plan_number = data.data.plan_number;
          this.sponsor = data.data.sponsor;
          this.introduce = data.data.item.introduce;
          this.annexs = data.data.item.items;
          this.fileList = [data.data.item.informed_consent];
          this.count = data.data.item.items.length;
          this.standard_constrain= data.data.item.standard_constrain;
          this.standard_selected=data.data.item.standard_selected;
          this.standard_exclude=data.data.item.standard_exclude;

            this.StandardSelectedCount=data.data.item.standard_selected.length;
            this.StandardExcludeCount=data.data.item.standard_exclude.length;
            this.can_direct_signature=data.data.item.can_direct_signature?'1':'0';
            this.need_video=data.data.item.need_video?'1':'0';
            this.video_text=data.data.item.video_text;
          console.log("列表", this.defaultFileList);
          console.log("列表annexs", this.annexs);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleChange(info) {
      // this.fileList = [...info.fileList];
      console.log("info", info);
      if (info.file.status === "removed") {
      }
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        this.$message.success(`${info.file.name} file uploaded successfully`);
        console.log("完成", info.file, info.fileList);
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} file upload failed.`);
      }
    },
    handleChange1({ fileList }) {
      console.log('handleChange1',fileList);
      if (fileList && fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]];
      }else{
      this.fileList = [];
      }
    },
    // handleChange1(info) {
    //   // this.fileList = [...info.fileList];
    //   console.log("info", info);
    //   if (info.file.status === "removed") {
    //     this.fileList=[];
    //   }
    //   if (info.file.status !== "uploading") {
    //     console.log(info.file, info.fileList);
    //   }
    //   if (info.file.status === "done") {
    //     this.fileList=info.fileList;
    //     this.$message.success(`${info.file.name} file uploaded successfully`);
    //   } else if (info.file.status === "error") {
    //     this.$message.error(`${info.file.name} file upload failed.`);
    //   }
    // },

    handleCancel() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      console.log("打开附件",file)
    },
    handleFormLayoutChange(e) {
      this.formLayout = e.target.value;
    },
    closeAnnex(i) {
      console.log("关闭嗯", i);
      this.closeList.push(i);
    },
      closeSS(i) {
          console.log("关闭嗯", i);
          this.closeSSList.push(i);
      },
      closeSE(i) {
          console.log("关闭嗯", i);
          this.closeSEList.push(i);
      },
      addStandardSelectedCount() {
          this.StandardSelectedCount += 1;
      },
      addStandardExcludeCount() {
          this.StandardExcludeCount += 1;
      },
    addAnnex() {
      this.count += 1;
    },
    handleSubmit() {
      this.form.validateFields((err, values) => {
        console.log("第一步", values);
        if (!err) {
          for (let i = 1; i <= this.count; i++) {
            console.log("看卡" + i, values);
            if (this.closeList.indexOf(i) !== -1) {
              values["title_" + i] = "";
              values["introduce_" + i] = "";
              values["annex_" + i] = "";
            } else {
              let annex = values["annex_" + i];
              if (annex) {
                if (annex.fileList) {
                  annex = annex.fileList;
                }
                values["annex_" + i] = annex.map(x => {
                  console.log("内部x", x, x.response);
                  if (x.response) {
                    return x.response;
                  }
                  return x;
                });
              } else {
                values["annex_" + i] = "";
              }
            }
          }
          if (!this.fileList || this.fileList.length < 1) {
            this.$message.error("请输入知情同意书");
            return;
          }
          values.informed_consent = this.fileList[0];
          if(values.informed_consent.response){
            values.informed_consent=values.informed_consent.response
          }
          console.log(this.form);
          console.log(values);
          values["count"] = this.count;
            values["standard_selected_count"]=this.StandardSelectedCount;
            values["standard_exclude_count"]=this.StandardExcludeCount;

          request({
            url: "/project/update/" + this.$route.query.the_id+"/",
            method: "POST",
            data: values
          }).then(response => {
            let data = response.data;
            if (data.success) {
              this.form.resetFields();
              this.$message.success(data.msg);
              this.$router.push({ path: "/project/all" });
            } else {
              this.$message.error(data.msg);
            }
            console.log(response);
          });
        }
      });
    }
  }
};
</script>
